import { render, staticRenderFns } from "./single-file-upload.vue?vue&type=template&id=5a34a122"
import script from "./single-file-upload.vue?vue&type=script&lang=ts"
export * from "./single-file-upload.vue?vue&type=script&lang=ts"
import style0 from "./single-file-upload.vue?vue&type=style&index=0&id=5a34a122&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports